import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DOB_DATE_FORMAT,
  TIME_FORMAT
} from '@bo-constants/member/members';
import { DateTime } from 'luxon';
import type { DateTimeFormat } from '@library/types/dates';
import { ET_TIMEZONE } from '@library/utils/dateTime';
import type { MemberFormattedDateTime } from '@library/types/members';

export const dateDisplay = (
  date: string,
  includeTime: boolean = false
): string => {
  const dateFormat = includeTime ? DATE_TIME_FORMAT : DATE_FORMAT;
  return DateTime.fromISO(date, { zone: ET_TIMEZONE }).toFormat(dateFormat);
};

export const dateOfBirthDisplay = (date: string): string => {
  return DateTime.fromISO(date).toFormat(DOB_DATE_FORMAT);
};

export const getDateTime = ({
  dateString
}: {
  dateString: string | undefined;
}): DateTime | undefined =>
  dateString ? DateTime.fromISO(dateString) : undefined;

export const getMemberDateTime = (date: string): DateTimeFormat => {
  const dateTime = DateTime.fromISO(date);

  return {
    date: dateTime.toFormat(DATE_FORMAT),
    time: dateTime.toFormat(TIME_FORMAT)
  };
};

export const getFormattedDateTime = ({
  dateTime
}: {
  dateTime: DateTime | undefined;
}): MemberFormattedDateTime => {
  if (!dateTime) {
    return { formattedDate: '', formattedTime: '' };
  }

  const formattedDate = dateTime.toFormat(DATE_FORMAT);
  const formattedTime = dateTime.toFormat(TIME_FORMAT);

  return {
    formattedDate,
    formattedTime
  };
};

export const getDollarAmount = ({
  amountInCents
}: {
  amountInCents: number;
}): number => amountInCents / 100;

export const getDollarAmountDisplay = ({
  dollarAmount
}: {
  dollarAmount: number;
}): string => `${dollarAmount > 0 ? '$' : '-$'}${Math.abs(dollarAmount)}`;

export const isConfirmationErrorMessage = (
  confirmationMessage?: string
): boolean => !!confirmationMessage?.toLowerCase().includes('error');
